// // src/pages/configuracoes/PainelWhatsapp.tsx
// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Container, Card, Button, Form,
//   Row, Col, Spinner, Table
// } from 'react-bootstrap';
// import {
//   FaSave, FaWhatsapp, FaCog, FaClock,
//   FaBell, FaCheckCircle, FaInfoCircle, FaPlay, FaEye, FaUndo
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// // ══════════════════════════════════════════════════════
// // TIPOS
// // ══════════════════════════════════════════════════════
// interface WhatsappConfig {
//   teamzapUrl:            string;
//   teamzapToken:          string;
//   batchSendEnabled:      boolean;
//   sendHour:              number;
//   sendMinute:            number;
//   delayMinSeconds:       number;
//   delayMaxSeconds:       number;
//   beforeDueEnabled:      boolean;
//   beforeDueDaysMin:      number;
//   beforeDueDaysMax:      number;
//   beforeDueMessage:      string;
//   dueTodayEnabled:       boolean;
//   dueTodayMessage:       string;
//   afterDueEnabled:       boolean;
//   afterDueDaysMin:       number;
//   afterDueDaysMax:       number;
//   afterDueMessage:       string;
//   paymentConfirmEnabled: boolean;
//   paymentConfirmMessage: string;
// }

// interface PreviewItem {
//   cliente:  string;
//   telefone: string;
//   mensagem: string;
// }

// // ══════════════════════════════════════════════════════
// // VARIÁVEIS DISPONÍVEIS
// // ══════════════════════════════════════════════════════
// const VARIABLES = [
//   { key: '{{CLIENTE}}',         label: 'Nome do cliente'     },
//   { key: '{{EMPRESA}}',         label: 'Nome da empresa'     },
//   { key: '{{FATURA}}',          label: 'Descrição da fatura' },
//   { key: '{{VENCIMENTO}}',      label: 'Data de vencimento'  },
//   { key: '{{DIAS}}',            label: 'Quantidade de dias'  },
//   { key: '{{VALOR_FATURA}}',    label: 'Valor da fatura'     },
//   { key: '{{LINK_BOLETO}}',     label: 'Link do boleto'      },
//   { key: '{{PIX_COPIA_COLA}}',  label: 'Pix copia e cola'    },
//   { key: '{{LINHA_DIGITAVEL}}', label: 'Linha digitável'     },
// ];

// // ══════════════════════════════════════════════════════
// // ESTADO INICIAL
// // ══════════════════════════════════════════════════════
// const INITIAL_CONFIG: WhatsappConfig = {
//   teamzapUrl:            '',
//   teamzapToken:          '',
//   batchSendEnabled:      false,
//   sendHour:              8,
//   sendMinute:            0,
//   delayMinSeconds:       15,
//   delayMaxSeconds:       90,
//   beforeDueEnabled:      false,
//   beforeDueDaysMin:      1,   // ✅ envia a partir de 1 dia antes
//   beforeDueDaysMax:      3,   // ✅ até 3 dias antes
//   beforeDueMessage:      'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* vence em {{DIAS}} dias (*{{VENCIMENTO}}*).\n\n_Desconsidere caso já tenha pago._\n_Mensagem automática, favor não responder._',
//   dueTodayEnabled:       false,
//   dueTodayMessage:       'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* vence *hoje* (*{{VENCIMENTO}}*).\n\n_Desconsidere caso já tenha pago._\n_Mensagem automática, favor não responder._',
//   afterDueEnabled:       false,
//   afterDueDaysMin:       1,
//   afterDueDaysMax:       15,
//   afterDueMessage:       'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* venceu há {{DIAS}} dias (*{{VENCIMENTO}}*).\n\n_Mensagem automática, favor não responder._',
//   paymentConfirmEnabled: false,
//   paymentConfirmMessage: 'Olá, *{{CLIENTE}}*! 🎉\n\nConfirmamos o recebimento do pagamento referente ao *{{FATURA}}*.\n\nObrigado pela confiança!\n\n_Mensagem automática, favor não responder._',
// };

// // ══════════════════════════════════════════════════════
// // SUB-COMPONENTES
// // ══════════════════════════════════════════════════════
// function ToggleSwitch({ enabled, onChange }: { enabled: boolean; onChange: (val: boolean) => void }) {
//   return (
//     <Form.Check
//       type="switch"
//       checked={enabled}
//       onChange={(e) => onChange(e.target.checked)}
//       className="fs-5 mb-0"
//     />
//   );
// }

// function VariablesInfo() {
//   const [open, setOpen] = useState(true);
//   return (
//     <div className="mb-2">
//       <Button
//         variant="outline-secondary"
//         size="sm"
//         onClick={() => setOpen(o => !o)}
//         className="d-flex align-items-center gap-2"
//       >
//         <FaInfoCircle />
//         {open ? 'Ocultar variáveis' : 'Variáveis disponíveis'}
//       </Button>

//       {open && (
//         <div className="mt-2 p-3 bg-light rounded border">
//           <p className="mb-2 small fw-semibold text-muted">💡 Clique em uma variável para copiar:</p>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
//             {VARIABLES.map(v => (
//               <button
//                 key={v.key}
//                 type="button"
//                 onClick={() => {
//                   navigator.clipboard.writeText(v.key);
//                   toast.info(`Copiado: ${v.key}`, { autoClose: 1500 });
//                 }}
//                 style={{
//                   display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
//                   background: '#fff', border: '1px solid #dee2e6', borderRadius: '8px',
//                   padding: '6px 12px', cursor: 'pointer', transition: 'all 0.15s', minWidth: '130px',
//                 }}
//                 onMouseEnter={e => {
//                   (e.currentTarget as HTMLButtonElement).style.borderColor = '#198754';
//                   (e.currentTarget as HTMLButtonElement).style.background = '#f0fff4';
//                 }}
//                 onMouseLeave={e => {
//                   (e.currentTarget as HTMLButtonElement).style.borderColor = '#dee2e6';
//                   (e.currentTarget as HTMLButtonElement).style.background = '#fff';
//                 }}
//               >
//                 <span style={{ fontFamily: 'monospace', fontSize: '0.78rem', fontWeight: 700, color: '#198754' }}>
//                   {v.key}
//                 </span>
//                 <span style={{ fontSize: '0.7rem', color: '#6c757d', marginTop: '1px' }}>
//                   {v.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//           <p className="mb-0 mt-3 small text-muted border-top pt-2">
//             Use <code>*texto*</code> para <strong>negrito</strong> no WhatsApp.
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }

// function NotificationSection({
//   title, icon, color, enabled, onToggle, onReset, children,
// }: {
//   title:     string;
//   icon:      React.ReactNode;
//   color:     string;
//   enabled:   boolean;
//   onToggle:  (val: boolean) => void;
//   onReset:   () => void;
//   children:  React.ReactNode;
// }) {
//   return (
//     <Card className={`shadow-sm h-100 ${enabled ? `border-${color}` : ''}`}>
//       <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
//         <div className="d-flex align-items-center gap-2">
//           <span style={{ color: `var(--bs-${color})` }}>{icon}</span>
//           <div>
//             <h6 className="mb-0">{title}</h6>
//             <p className={`mb-0 small fw-semibold text-${enabled ? color : 'secondary'}`}>
//               {enabled ? '● Ativo' : '○ Inativo'}
//             </p>
//           </div>
//         </div>
//         <div className="d-flex align-items-center gap-2">
//           <Button
//             variant="outline-secondary"
//             size="sm"
//             type="button"
//             title="Resetar mensagem para o padrão"
//             onClick={() => {
//               if (window.confirm(`⚠️ Resetar "${title}" para o padrão?`)) {
//                 onReset();
//                 toast.info(`"${title}" resetado para o padrão.`);
//               }
//             }}
//           >
//             <FaUndo />
//           </Button>
//           <ToggleSwitch enabled={enabled} onChange={onToggle} />
//         </div>
//       </Card.Header>
//       {enabled && <Card.Body>{children}</Card.Body>}
//     </Card>
//   );
// }

// // ══════════════════════════════════════════════════════
// // COMPONENTE PRINCIPAL
// // ══════════════════════════════════════════════════════
// export default function PainelWhatsapp() {
//   const [loading,  setLoading]  = useState(true);
//   const [saving,   setSaving]   = useState(false);
//   const [testing,  setTesting]  = useState(false);
//   const [preview,  setPreview]  = useState<PreviewItem[]>([]);
//   const [config,   setConfig]   = useState<WhatsappConfig>(INITIAL_CONFIG);

//   // ── Carrega configurações ──
//   useEffect(() => {
//     (async () => {
//       try {
//         const [whatsappRes, companyRes] = await Promise.all([
//           api.get('/whatsapp/config'),
//           api.get('/company/settings'),
//         ]);

//         // 🔍 Debug (remova depois de confirmar que está OK)
//         console.log('🔵 [WhatsApp Config] Response:', whatsappRes.data);
//         console.log('🔵 [Company Settings] Response:', companyRes.data);

//         // ✅ Filtra null/undefined para não sobrescrever INITIAL_CONFIG
//         const whatsappData = Object.fromEntries(
//           Object.entries(whatsappRes.data || {}).filter(
//             ([_, v]) => v !== null && v !== undefined
//           )
//         );

//         setConfig(prev => ({
//           ...prev,
//           ...whatsappData,
//           teamzapUrl:   companyRes.data?.teamzapUrl   ?? '',
//           teamzapToken: companyRes.data?.teamzapToken ?? '',
//         }));
//       } catch (error) {
//         console.error('[WhatsApp Config] Erro ao carregar:', error);
//         toast.error('Erro ao carregar configurações de WhatsApp.');
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   const set = useCallback(
//     <K extends keyof WhatsappConfig>(key: K, value: WhatsappConfig[K]) => {
//       setConfig(prev => ({ ...prev, [key]: value }));
//     }, []
//   );

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value, type } = e.target;
//     const checked = (e.target as HTMLInputElement).checked;
//     setConfig(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value,
//     }));
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     // ✅ Validações corrigidas
//     if (config.delayMinSeconds >= config.delayMaxSeconds) {
//       toast.warning('O delay mínimo deve ser menor que o delay máximo.');
//       return;
//     }
//     if (config.beforeDueEnabled && config.beforeDueDaysMin > config.beforeDueDaysMax) {
//       toast.warning('"Antes do vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
//       return;
//     }
//     if (config.afterDueEnabled && config.afterDueDaysMin > config.afterDueDaysMax) {
//       toast.warning('"Após vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
//       return;
//     }

//     try {
//       setSaving(true);
//       await api.put('/whatsapp/config', config);
//       toast.success('Configurações salvas com sucesso!');
//     } catch (error: unknown) {
//       const err = error as { response?: { data?: { error?: string } } };
//       toast.error(err.response?.data?.error || 'Erro ao salvar configurações.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleTestRun = async (dryRun: boolean) => {
//     try {
//       setTesting(true);
//       setPreview([]);

//       const { data } = await api.post('/whatsapp/test-run', { dryRun });

//       if (data.total === 0) {
//         toast.info('Nenhuma notificação pendente encontrada para hoje.');
//         return;
//       }

//       if (dryRun) {
//         setPreview(data.data ?? []);
//         toast.info(`${data.total} notificação(ões) encontradas. Veja o preview abaixo.`);
//       } else {
//         toast.success(data.message);
//       }
//     } catch (err: unknown) {
//       const e = err as { response?: { data?: { error?: string } } };
//       toast.error(e.response?.data?.error || 'Erro ao executar teste.');
//     } finally {
//       setTesting(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center mt-5 pt-5">
//         <Spinner animation="border" variant="success" />
//         <div className="mt-2 text-muted">Carregando configurações de WhatsApp...</div>
//       </div>
//     );
//   }

//   return (
//     <Container fluid className="p-4">

//       {/* ── Cabeçalho ── */}
//       <div className="mb-4">
//         <h1 className="mb-0 d-flex align-items-center gap-2">
//           <FaWhatsapp className="text-success" />
//           Painel de WhatsApp
//         </h1>
//         <small className="text-muted">Configurações de notificações automáticas de cobrança</small>
//       </div>

//       <Form onSubmit={handleSubmit}>
//         <div className="d-flex flex-column gap-4">

//           {/* ── Variáveis ── */}
//           <VariablesInfo />

//           {/* ══════════════════════════════════════
//               BLOCO 1 — ENVIO EM LOTE
//           ══════════════════════════════════════ */}
//           <Card className={`shadow-sm ${config.batchSendEnabled ? 'border-success' : ''}`}>
//             <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
//               <div className="d-flex align-items-center gap-2">
//                 <FaCog className="text-success fs-5" />
//                 <div>
//                   <h6 className="mb-0">Configuração de Envio</h6>
//                   <p className={`mb-0 small fw-semibold text-${config.batchSendEnabled ? 'success' : 'secondary'}`}>
//                     {config.batchSendEnabled ? '● Ativo' : '○ Inativo'}
//                   </p>
//                 </div>
//               </div>
//               <ToggleSwitch enabled={config.batchSendEnabled} onChange={v => set('batchSendEnabled', v)} />
//             </Card.Header>

//             {config.batchSendEnabled && (
//               <Card.Body>
//                 <p className="text-muted small mb-4">
//                   Ativa o envio automático e em massa de mensagens. Configure o horário e o intervalo entre os envios.
//                 </p>
//                 <Row className="g-3">

//                   {/* ✅ TeamZap — Card simplificado */}
//                   <Col md={8}>
//                     <Card className="bg-light border-0 p-3 h-100">
//                       <div className="d-flex align-items-center gap-2 mb-3">
//                         <FaWhatsapp className="text-success" />
//                         <strong>TeamZap — Notificações WhatsApp</strong>
//                       </div>
//                       <Row className="g-3">
//                         <Col md={7}>
//                           <Form.Group className="mb-0">
//                             <Form.Label className="small">URL do Webhook</Form.Label>
//                             <Form.Control
//                               type="text"
//                               name="teamzapUrl"
//                               value={config.teamzapUrl}
//                               onChange={handleChange}
//                               placeholder="https://..."
//                             />
//                           </Form.Group>
//                         </Col>
//                         <Col md={5}>
//                           <Form.Group className="mb-0">
//                             <Form.Label className="small">Token</Form.Label>
//                             <Form.Control
//                               type="password"
//                               name="teamzapToken"
//                               value={config.teamzapToken}
//                               onChange={handleChange}
//                               autoComplete="off"
//                             />
//                           </Form.Group>
//                         </Col>
//                       </Row>
//                     </Card>
//                   </Col>

//                   {/* ✅ Intervalo Aleatório — Row corrigido */}
//                   <Col md={4}>
//                     <Card className="bg-light border-0 p-3 h-100">
//                       <div className="d-flex align-items-center gap-2 mb-3">
//                         <FaClock className="text-warning" />
//                         <strong>Intervalo Aleatório</strong>
//                       </div>
//                       <Row className="g-2">
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label className="small">Mín. (s)</Form.Label>
//                             <Form.Control
//                               type="number" name="delayMinSeconds"
//                               value={config.delayMinSeconds} onChange={handleChange}
//                               min={1} max={300}
//                             />
//                           </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label className="small">Máx. (s)</Form.Label>
//                             <Form.Control
//                               type="number" name="delayMaxSeconds"
//                               value={config.delayMaxSeconds} onChange={handleChange}
//                               min={1} max={300}
//                             />
//                           </Form.Group>
//                         </Col>
//                       </Row>
//                       <small className="text-muted mt-2">
//                         Aguarda entre <strong>{config.delayMinSeconds}s</strong> e{' '}
//                         <strong>{config.delayMaxSeconds}s</strong> entre cada mensagem.
//                       </small>
//                     </Card>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             )}
//           </Card>

//           {/* ══════════════════════════════════════
//               BLOCOS — ANTES DO VENC. | VENCE HOJE
//           ══════════════════════════════════════ */}
//           <Row className="g-4">
//             <Col md={6}>
//               <NotificationSection
//                 title="Antes do Vencimento" icon={<FaBell />} color="warning"
//                 enabled={config.beforeDueEnabled} onToggle={v => set('beforeDueEnabled', v)}
//                 onReset={() => set('beforeDueMessage', INITIAL_CONFIG.beforeDueMessage)}
//               >
//                 <Row className="g-3 mb-3">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias antes (mínimo)</Form.Label>
//                       <Form.Control
//                         type="number" name="beforeDueDaysMin"
//                         value={config.beforeDueDaysMin} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 1</Form.Text>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias antes (máximo)</Form.Label>
//                       <Form.Control
//                         type="number" name="beforeDueDaysMax"
//                         value={config.beforeDueDaysMax} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 3</Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <div className="alert alert-warning py-2 small">
//                   ⚠️ Enviado de <strong>{config.beforeDueDaysMin}</strong> até{' '}
//                   <strong>{config.beforeDueDaysMax}</strong> dia(s) antes do vencimento.
//                 </div>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Mensagem</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="beforeDueMessage"
//                     value={config.beforeDueMessage} onChange={handleChange}
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>

//             <Col md={6}>
//               <NotificationSection
//                 title="Vence Hoje" icon={<FaBell />} color="primary"
//                 enabled={config.dueTodayEnabled} onToggle={v => set('dueTodayEnabled', v)}
//                 onReset={() => set('dueTodayMessage', INITIAL_CONFIG.dueTodayMessage)}
//               >
//                 <div className="alert alert-primary py-2 small mb-3">
//                   ℹ️ Enviada <strong>no dia do vencimento</strong>.
//                 </div>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Mensagem</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="dueTodayMessage"
//                     value={config.dueTodayMessage} onChange={handleChange}
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>
//           </Row>

//           {/* ══════════════════════════════════════
//               BLOCOS — APÓS VENC. | CONFIRMAÇÃO
//           ══════════════════════════════════════ */}
//           <Row className="g-4">
//             <Col md={6}>
//               <NotificationSection
//                 title="Após o Vencimento" icon={<FaBell />} color="danger"
//                 enabled={config.afterDueEnabled} onToggle={v => set('afterDueEnabled', v)}
//                 onReset={() => set('afterDueMessage', INITIAL_CONFIG.afterDueMessage)}
//               >
//                 <Row className="g-3 mb-3">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias após (mínimo)</Form.Label>
//                       <Form.Control
//                         type="number" name="afterDueDaysMin"
//                         value={config.afterDueDaysMin} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 1</Form.Text>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias após (máximo)</Form.Label>
//                       <Form.Control
//                         type="number" name="afterDueDaysMax"
//                         value={config.afterDueDaysMax} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 15</Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <div className="alert alert-danger py-2 small">
//                   ⚠️ Enviado de <strong>{config.afterDueDaysMin}</strong> até{' '}
//                   <strong>{config.afterDueDaysMax}</strong> dia(s) após o vencimento.
//                 </div>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Mensagem</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="afterDueMessage"
//                     value={config.afterDueMessage} onChange={handleChange}
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>

//             <Col md={6}>
//               <NotificationSection
//                 title="Confirmação de Pagamento" icon={<FaCheckCircle />} color="success"
//                 enabled={config.paymentConfirmEnabled} onToggle={v => set('paymentConfirmEnabled', v)}
//                 onReset={() => set('paymentConfirmMessage', INITIAL_CONFIG.paymentConfirmMessage)}
//               >
//                 <div className="alert alert-success py-2 small mb-3">
//                   ✅ Enviada automaticamente quando o pagamento é confirmado.
//                 </div>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Mensagem</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="paymentConfirmMessage"
//                     value={config.paymentConfirmMessage} onChange={handleChange}
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>
//           </Row>

//           {/* ══════════════════════════════════════
//               BOTÕES — TESTE + SALVAR
//           ══════════════════════════════════════ */}
//           <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

//             {/* 🔄 Resetar tudo */}
//             <Button
//               variant="outline-secondary"
//               type="button"
//               disabled={saving || testing}
//               onClick={() => {
//                 if (window.confirm('⚠️ Isso vai resetar TODAS as configurações para o padrão. Confirmar?')) {
//                   setConfig(INITIAL_CONFIG);
//                   toast.info('Todas as configurações resetadas para o padrão.');
//                 }
//               }}
//             >
//               <FaUndo className="me-2" />
//               Resetar Tudo
//             </Button>

//             {/* 🔍 Simular */}
//             <Button
//               variant="outline-info"
//               type="button"
//               disabled={testing || saving}
//               onClick={() => handleTestRun(true)}
//             >
//               {testing
//                 ? <Spinner size="sm" animation="border" className="me-2" />
//                 : <FaEye className="me-2" />
//               }
//               Simular Envio
//             </Button>

//             {/* 🚀 Disparar agora */}
//             <Button
//               variant="outline-warning"
//               type="button"
//               disabled={testing || saving}
//               onClick={() => {
//                 if (window.confirm('⚠️ Isso vai enviar mensagens REAIS agora para os clientes. Confirmar?')) {
//                   handleTestRun(false);
//                 }
//               }}
//             >
//               {testing
//                 ? <Spinner size="sm" animation="border" className="me-2" />
//                 : <FaPlay className="me-2" />
//               }
//               Disparar Agora
//             </Button>

//             {/* 💾 Salvar */}
//             <Button variant="success" type="submit" disabled={saving || testing} size="lg">
//               {saving
//                 ? <><Spinner size="sm" className="me-2" />Salvando...</>
//                 : <><FaSave className="me-2" />Salvar Configurações</>
//               }
//             </Button>
//           </div>

//           {/* ══════════════════════════════════════
//               PREVIEW — resultado do Dry Run
//           ══════════════════════════════════════ */}
//           {preview.length > 0 && (
//             <Card className="border-info shadow-sm">
//               <Card.Header className="bg-info bg-opacity-10 d-flex justify-content-between align-items-center">
//                 <strong className="d-flex align-items-center gap-2">
//                   <FaEye className="text-info" />
//                   Preview — {preview.length} notificação(ões) seriam enviadas
//                 </strong>
//                 <Button size="sm" variant="outline-secondary" onClick={() => setPreview([])}>
//                   Fechar
//                 </Button>
//               </Card.Header>
//               <Card.Body className="p-0">
//                 <Table hover responsive className="mb-0 small">
//                   <thead className="table-light">
//                     <tr>
//                       <th style={{ width: '20%' }}>Cliente</th>
//                       <th style={{ width: '15%' }}>Telefone</th>
//                       <th>Mensagem</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {preview.map((p, i) => (
//                       <tr key={i}>
//                         <td className="fw-semibold">{p.cliente}</td>
//                         <td><code>{p.telefone}</code></td>
//                         <td>
//                           <pre style={{ fontSize: '0.75rem', whiteSpace: 'pre-wrap', margin: 0, fontFamily: 'inherit' }}>
//                             {p.mensagem}
//                           </pre>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           )}

//         </div>
//       </Form>
//     </Container>
//   );
// }


// src/pages/configuracoes/PainelWhatsapp.tsx
import React, { useState, useEffect, useCallback } from 'react';
import {
  Container, Card, Button, Form,
  Row, Col, Spinner, Table
} from 'react-bootstrap';
import {
  FaSave, FaWhatsapp, FaCog, FaClock,
  FaBell, FaCheckCircle, FaInfoCircle, FaPlay, FaEye, FaUndo,
  FaChevronDown, FaChevronUp, FaLock, FaPlug,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';

// ══════════════════════════════════════════════════════
// TIPOS
// ══════════════════════════════════════════════════════
interface WhatsappConfig {
  // TeamZap (vem de /company/settings)
  teamzapUrl:            string;
  teamzapToken:          string;
  hasTeamzapToken?:      boolean;
  // Envio em lote
  batchSendEnabled:      boolean;
  sendHour:              number;
  sendMinute:            number;
  delayMinSeconds:       number;
  delayMaxSeconds:       number;
  // Antes do vencimento
  beforeDueEnabled:      boolean;
  beforeDueDaysMin:      number;
  beforeDueDaysMax:      number;
  beforeDueMessage:      string;
  // Vence hoje
  dueTodayEnabled:       boolean;
  dueTodayMessage:       string;
  // Após vencimento
  afterDueEnabled:       boolean;
  afterDueDaysMin:       number;
  afterDueDaysMax:       number;
  afterDueMessage:       string;
  // Confirmação
  paymentConfirmEnabled: boolean;
  paymentConfirmMessage: string;
}

interface PreviewItem {
  cliente:  string;
  telefone: string;
  mensagem: string;
}

// ══════════════════════════════════════════════════════
// VARIÁVEIS DISPONÍVEIS
// ══════════════════════════════════════════════════════
const VARIABLES = [
  { key: '{{CLIENTE}}',         label: 'Nome do cliente'     },
  { key: '{{EMPRESA}}',         label: 'Nome da empresa'     },
  { key: '{{FATURA}}',          label: 'Descrição da fatura' },
  { key: '{{VENCIMENTO}}',      label: 'Data de vencimento'  },
  { key: '{{DIAS}}',            label: 'Quantidade de dias'  },
  { key: '{{VALOR_FATURA}}',    label: 'Valor da fatura'     },
  { key: '{{LINK_BOLETO}}',     label: 'Link do boleto'      },
  { key: '{{PIX_COPIA_COLA}}',  label: 'Pix copia e cola'    },
  { key: '{{LINHA_DIGITAVEL}}', label: 'Linha digitável'     },
];

// ══════════════════════════════════════════════════════
// ESTADO INICIAL
// ══════════════════════════════════════════════════════
const INITIAL_CONFIG: WhatsappConfig = {
  teamzapUrl:            '',
  teamzapToken:          '',
  hasTeamzapToken:       false,
  batchSendEnabled:      false,
  sendHour:              8,
  sendMinute:            0,
  delayMinSeconds:       15,
  delayMaxSeconds:       90,
  beforeDueEnabled:      false,
  beforeDueDaysMin:      1,
  beforeDueDaysMax:      3,
  beforeDueMessage:      'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* vence em {{DIAS}} dias (*{{VENCIMENTO}}*).\n\n_Desconsidere caso já tenha pago._\n_Mensagem automática, favor não responder._',
  dueTodayEnabled:       false,
  dueTodayMessage:       'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* vence *hoje* (*{{VENCIMENTO}}*).\n\n_Desconsidere caso já tenha pago._\n_Mensagem automática, favor não responder._',
  afterDueEnabled:       false,
  afterDueDaysMin:       1,
  afterDueDaysMax:       15,
  afterDueMessage:       'Olá, *{{CLIENTE}}*.\n\nA *{{EMPRESA}}* informa: seu boleto referente ao *{{FATURA}}* venceu há {{DIAS}} dias (*{{VENCIMENTO}}*).\n\n_Mensagem automática, favor não responder._',
  paymentConfirmEnabled: false,
  paymentConfirmMessage: 'Olá, *{{CLIENTE}}*! 🎉\n\nConfirmamos o recebimento do pagamento referente ao *{{FATURA}}*.\n\nObrigado pela confiança!\n\n_Mensagem automática, favor não responder._',
};

// Lista de campos considerados "mensagens" (para reset parcial)
const MESSAGE_FIELDS: (keyof WhatsappConfig)[] = [
  'batchSendEnabled', 'sendHour', 'sendMinute',
  'delayMinSeconds', 'delayMaxSeconds',
  'beforeDueEnabled', 'beforeDueDaysMin', 'beforeDueDaysMax', 'beforeDueMessage',
  'dueTodayEnabled', 'dueTodayMessage',
  'afterDueEnabled', 'afterDueDaysMin', 'afterDueDaysMax', 'afterDueMessage',
  'paymentConfirmEnabled', 'paymentConfirmMessage',
];

// ══════════════════════════════════════════════════════
// SUB-COMPONENTES
// ══════════════════════════════════════════════════════
function ToggleSwitch({ enabled, onChange }: { enabled: boolean; onChange: (val: boolean) => void }) {
  return (
    <Form.Check
      type="switch"
      checked={enabled}
      onChange={(e) => onChange(e.target.checked)}
      className="fs-5 mb-0"
    />
  );
}

function VariablesInfo() {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-2">
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(o => !o)}
        className="d-flex align-items-center gap-2"
      >
        <FaInfoCircle />
        {open ? 'Ocultar variáveis' : 'Variáveis disponíveis'}
      </Button>

      {open && (
        <div className="mt-2 p-3 bg-light rounded border">
          <p className="mb-2 small fw-semibold text-muted">💡 Clique em uma variável para copiar:</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {VARIABLES.map(v => (
              <button
                key={v.key}
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(v.key);
                  toast.info(`Copiado: ${v.key}`, { autoClose: 1500 });
                }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                  background: '#fff', border: '1px solid #dee2e6', borderRadius: '8px',
                  padding: '6px 12px', cursor: 'pointer', transition: 'all 0.15s', minWidth: '130px',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLButtonElement).style.borderColor = '#198754';
                  (e.currentTarget as HTMLButtonElement).style.background = '#f0fff4';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLButtonElement).style.borderColor = '#dee2e6';
                  (e.currentTarget as HTMLButtonElement).style.background = '#fff';
                }}
              >
                <span style={{ fontFamily: 'monospace', fontSize: '0.78rem', fontWeight: 700, color: '#198754' }}>
                  {v.key}
                </span>
                <span style={{ fontSize: '0.7rem', color: '#6c757d', marginTop: '1px' }}>
                  {v.label}
                </span>
              </button>
            ))}
          </div>
          <p className="mb-0 mt-3 small text-muted border-top pt-2">
            Use <code>*texto*</code> para <strong>negrito</strong> no WhatsApp.
          </p>
        </div>
      )}
    </div>
  );
}

function NotificationSection({
  title, icon, color, enabled, onToggle, onReset, children,
}: {
  title:     string;
  icon:      React.ReactNode;
  color:     string;
  enabled:   boolean;
  onToggle:  (val: boolean) => void;
  onReset:   () => void;
  children:  React.ReactNode;
}) {
  return (
    <Card className={`shadow-sm h-100 ${enabled ? `border-${color}` : ''}`}>
      <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ color: `var(--bs-${color})` }}>{icon}</span>
          <div>
            <h6 className="mb-0">{title}</h6>
            <p className={`mb-0 small fw-semibold text-${enabled ? color : 'secondary'}`}>
              {enabled ? '● Ativo' : '○ Inativo'}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="outline-secondary"
            size="sm"
            type="button"
            title="Resetar mensagem para o padrão"
            onClick={() => {
              if (window.confirm(`⚠️ Resetar "${title}" para o padrão?`)) {
                onReset();
                toast.info(`"${title}" resetado para o padrão.`);
              }
            }}
          >
            <FaUndo />
          </Button>
          <ToggleSwitch enabled={enabled} onChange={onToggle} />
        </div>
      </Card.Header>
      {enabled && <Card.Body>{children}</Card.Body>}
    </Card>
  );
}

// ══════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL
// ══════════════════════════════════════════════════════
export default function PainelWhatsapp() {
  const [loading,          setLoading]          = useState(true);
  const [savingTeamzap,    setSavingTeamzap]    = useState(false);
  const [savingMsgs,       setSavingMsgs]       = useState(false);
  const [testing,          setTesting]          = useState(false);
  const [preview,          setPreview]          = useState<PreviewItem[]>([]);
  const [config,           setConfig]           = useState<WhatsappConfig>(INITIAL_CONFIG);
  const [showTeamzapToken, setShowTeamzapToken] = useState(false);
  const [teamzapOpen,      setTeamzapOpen]      = useState(false);

  // ── Carrega configurações ──
  useEffect(() => {
    (async () => {
      try {
        const [whatsappRes, companyRes] = await Promise.all([
          api.get('/whatsapp/config'),
          api.get('/company/settings'),
        ]);

        // Filtra null/undefined para não sobrescrever INITIAL_CONFIG
        const whatsappData = Object.fromEntries(
          Object.entries(whatsappRes.data || {}).filter(
            ([_, v]) => v !== null && v !== undefined
          )
        );

        const hasToken = !!companyRes.data?.hasTeamzapToken;

        setConfig(prev => ({
          ...prev,
          ...whatsappData,
          teamzapUrl:      companyRes.data?.teamzapUrl   ?? '',
          teamzapToken:    '',
          hasTeamzapToken: hasToken,
        }));

        // Abre automaticamente se ainda não tem token
        setTeamzapOpen(!hasToken);

      } catch (error) {
        console.error('[WhatsApp Config] Erro ao carregar:', error);
        toast.error('Erro ao carregar configurações de WhatsApp.');
        setTeamzapOpen(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const set = useCallback(
    <K extends keyof WhatsappConfig>(key: K, value: WhatsappConfig[K]) => {
      setConfig(prev => ({ ...prev, [key]: value }));
    }, []
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value,
    }));
  };

  // ═══════════════════════════════════════════
  // SALVA APENAS TEAMZAP (vai para /company/settings)
  // ═══════════════════════════════════════════
  const handleSaveTeamzap = async () => {
    if (!config.teamzapUrl.trim()) {
      toast.warning('Informe a URL do webhook do TeamZap.');
      return;
    }
    if (!config.hasTeamzapToken && !config.teamzapToken.trim()) {
      toast.warning('Informe o token do TeamZap.');
      return;
    }

    try {
      setSavingTeamzap(true);

      const payload: Record<string, any> = {
        teamzapUrl: config.teamzapUrl,
      };

      // Só envia o token se foi preenchido (preserva o atual se vazio)
      if (config.teamzapToken.trim()) {
        payload.teamzapToken = config.teamzapToken;
      }

      await api.put('/company/settings', payload);
      toast.success('Integração TeamZap salva!');

      // Recarrega pra atualizar hasTeamzapToken e limpar o campo
      const { data } = await api.get('/company/settings');
      setConfig(prev => ({
        ...prev,
        teamzapUrl:      data?.teamzapUrl ?? '',
        teamzapToken:    '',
        hasTeamzapToken: !!data?.hasTeamzapToken,
      }));

      // Fecha o card após salvar
      setTeamzapOpen(false);

    } catch (error: unknown) {
      const err = error as { response?: { data?: { error?: string } } };
      toast.error(err.response?.data?.error || 'Erro ao salvar TeamZap.');
    } finally {
      setSavingTeamzap(false);
    }
  };

  // ═══════════════════════════════════════════
  // SALVA APENAS MENSAGENS (vai para /whatsapp/config)
  // ═══════════════════════════════════════════
  const handleSaveMessages = async (e: React.FormEvent) => {
    e.preventDefault();

    if (config.delayMinSeconds >= config.delayMaxSeconds) {
      toast.warning('O delay mínimo deve ser menor que o delay máximo.');
      return;
    }
    if (config.beforeDueEnabled && config.beforeDueDaysMin > config.beforeDueDaysMax) {
      toast.warning('"Antes do vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
      return;
    }
    if (config.afterDueEnabled && config.afterDueDaysMin > config.afterDueDaysMax) {
      toast.warning('"Após vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
      return;
    }

    try {
      setSavingMsgs(true);

      // Remove campos do TeamZap do payload
      const { teamzapUrl, teamzapToken, hasTeamzapToken, ...messagesData } = config;

      await api.put('/whatsapp/config', messagesData);
      toast.success('Mensagens salvas com sucesso!');

    } catch (error: unknown) {
      const err = error as { response?: { data?: { error?: string } } };
      toast.error(err.response?.data?.error || 'Erro ao salvar mensagens.');
    } finally {
      setSavingMsgs(false);
    }
  };

  const handleTestRun = async (dryRun: boolean) => {
    try {
      setTesting(true);
      setPreview([]);

      const { data } = await api.post('/whatsapp/test-run', { dryRun });

      if (data.total === 0) {
        toast.info('Nenhuma notificação pendente encontrada para hoje.');
        return;
      }

      if (dryRun) {
        setPreview(data.data ?? []);
        toast.info(`${data.total} notificação(ões) encontradas. Veja o preview abaixo.`);
      } else {
        toast.success(data.message);
      }
    } catch (err: unknown) {
      const e = err as { response?: { data?: { error?: string } } };
      toast.error(e.response?.data?.error || 'Erro ao executar teste.');
    } finally {
      setTesting(false);
    }
  };

  // Reset apenas das mensagens (mantém TeamZap)
  const handleResetMessages = () => {
    if (!window.confirm('⚠️ Isso vai resetar TODAS as mensagens para o padrão. Confirmar?')) {
      return;
    }
    setConfig(prev => {
      const updated = { ...prev };
      MESSAGE_FIELDS.forEach(field => {
        (updated as any)[field] = INITIAL_CONFIG[field];
      });
      return updated;
    });
    toast.info('Mensagens resetadas para o padrão.');
  };

  if (loading) {
    return (
      <div className="text-center mt-5 pt-5">
        <Spinner animation="border" variant="success" />
        <div className="mt-2 text-muted">Carregando configurações de WhatsApp...</div>
      </div>
    );
  }

  return (
    <Container fluid className="p-4">

      {/* ── Cabeçalho ── */}
      <div className="mb-4">
        <h1 className="mb-0 d-flex align-items-center gap-2">
          <FaWhatsapp className="text-success" />
          Painel de WhatsApp
        </h1>
        <small className="text-muted">Configurações de notificações automáticas de cobrança</small>
      </div>

      <div className="d-flex flex-column gap-4">

        {/* ── Variáveis ── */}
        <VariablesInfo />

        {/* ══════════════════════════════════════
            BLOCO TEAMZAP — colapsável, com botão próprio
        ══════════════════════════════════════ */}
        <Card className="shadow-sm border-success border-opacity-50">
          <Card.Header
            className="bg-white d-flex align-items-center justify-content-between py-3"
            onClick={() => setTeamzapOpen(o => !o)}
            style={{ cursor: 'pointer', userSelect: 'none' }}
          >
            <div className="d-flex align-items-center gap-2">
              <FaPlug className="text-success fs-5" />
              <div>
                <h6 className="mb-0 d-flex align-items-center gap-2">
                  Integração TeamZap — WhatsApp
                  {teamzapOpen
                    ? <FaChevronUp   size={12} className="text-muted" />
                    : <FaChevronDown size={12} className="text-muted" />
                  }
                </h6>
                <p className="mb-0 small text-muted">Credenciais para envio de mensagens via TeamZap</p>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              {config.hasTeamzapToken ? (
                <span
                  className="d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: '#d1e7dd',
                    color:           '#0f5132',
                    border:          '1px solid #badbcc',
                    borderRadius:    12,
                    padding:         '3px 10px',
                    fontSize:        11,
                    fontWeight:      600,
                  }}
                >
                  <FaCheckCircle size={10} /> Configurado
                </span>
              ) : (
                <span
                  className="d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: '#fff3cd',
                    color:           '#664d03',
                    border:          '1px solid #ffecb5',
                    borderRadius:    12,
                    padding:         '3px 10px',
                    fontSize:        11,
                    fontWeight:      600,
                  }}
                >
                  ⚠️ Não configurado
                </span>
              )}
            </div>
          </Card.Header>

          {teamzapOpen && (
            <Card.Body onClick={(e) => e.stopPropagation()}>
              <Row className="g-3">

                <Col md={7}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">URL do Webhook</Form.Label>
                    <Form.Control
                      type="text"
                      name="teamzapUrl"
                      value={config.teamzapUrl}
                      onChange={handleChange}
                      placeholder="https://api.teamzap.com.br/..."
                    />
                    <Form.Text className="text-muted">Endpoint fornecido pelo TeamZap</Form.Text>
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold d-flex align-items-center justify-content-between">
                      <span>
                        <FaLock className="me-1 text-muted" />
                        Token
                      </span>
                      {config.hasTeamzapToken && !config.teamzapToken && (
                        <span
                          className="d-inline-flex align-items-center gap-1"
                          style={{
                            backgroundColor: '#d1e7dd',
                            color:           '#0f5132',
                            border:          '1px solid #badbcc',
                            borderRadius:    10,
                            padding:         '2px 7px',
                            fontSize:        10,
                            fontWeight:      600,
                          }}
                        >
                          🔒 Salvo
                        </span>
                      )}
                    </Form.Label>
                    <div className="input-group">
                      <Form.Control
                        type={showTeamzapToken ? 'text' : 'password'}
                        name="teamzapToken"
                        value={config.teamzapToken}
                        onChange={handleChange}
                        placeholder={
                          config.hasTeamzapToken
                            ? '••••••••  (deixe vazio p/ manter)'
                            : 'Cole seu token aqui'
                        }
                        autoComplete="new-password"
                        style={{
                          backgroundColor: config.hasTeamzapToken && !config.teamzapToken ? '#f0fdf4' : undefined,
                          borderColor:     config.hasTeamzapToken && !config.teamzapToken ? '#198754' : undefined,
                        }}
                      />
                      <Button
                        variant="outline-secondary"
                        type="button"
                        onClick={() => setShowTeamzapToken(p => !p)}
                      >
                        {showTeamzapToken ? '🙈' : '👁️'}
                      </Button>
                    </div>
                    <Form.Text className="text-muted">
                      {config.hasTeamzapToken
                        ? 'Digite um novo token apenas para substituir o atual.'
                        : 'Token de autenticação do TeamZap.'
                      }
                    </Form.Text>
                  </Form.Group>
                </Col>

              </Row>

              <div className="alert alert-info py-2 small mt-3 mb-3 d-flex align-items-center gap-2">
                <FaInfoCircle />
                <span>
                  Após salvar a integração, configure as mensagens abaixo e ative o envio em lote quando estiver pronto.
                </span>
              </div>

              {/* Botão próprio do TeamZap */}
              <div className="d-flex justify-content-end border-top pt-3">
                <Button
                  variant="success"
                  type="button"
                  onClick={handleSaveTeamzap}
                  disabled={savingTeamzap || savingMsgs}
                >
                  {savingTeamzap
                    ? <><Spinner size="sm" className="me-2" />Salvando TeamZap...</>
                    : <><FaSave className="me-2" />Salvar TeamZap</>
                  }
                </Button>
              </div>
            </Card.Body>
          )}
        </Card>

        {/* ══════════════════════════════════════
            FORM DAS MENSAGENS
        ══════════════════════════════════════ */}
        <Form onSubmit={handleSaveMessages}>
          <div className="d-flex flex-column gap-4">

            {/* ══════════════════════════════════════
                BLOCOS — ANTES DO VENC. | VENCE HOJE
            ══════════════════════════════════════ */}
            <Row className="g-4">
              <Col md={6}>
                <NotificationSection
                  title="Antes do Vencimento" icon={<FaBell />} color="warning"
                  enabled={config.beforeDueEnabled} onToggle={v => set('beforeDueEnabled', v)}
                  onReset={() => set('beforeDueMessage', INITIAL_CONFIG.beforeDueMessage)}
                >
                  <Row className="g-3 mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias antes (mínimo)</Form.Label>
                        <Form.Control
                          type="number" name="beforeDueDaysMin"
                          value={config.beforeDueDaysMin} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 1</Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias antes (máximo)</Form.Label>
                        <Form.Control
                          type="number" name="beforeDueDaysMax"
                          value={config.beforeDueDaysMax} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 3</Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="alert alert-warning py-2 small">
                    ⚠️ Enviado de <strong>{config.beforeDueDaysMin}</strong> até{' '}
                    <strong>{config.beforeDueDaysMax}</strong> dia(s) antes do vencimento.
                  </div>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Mensagem</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="beforeDueMessage"
                      value={config.beforeDueMessage} onChange={handleChange}
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>

              <Col md={6}>
                <NotificationSection
                  title="Vence Hoje" icon={<FaBell />} color="primary"
                  enabled={config.dueTodayEnabled} onToggle={v => set('dueTodayEnabled', v)}
                  onReset={() => set('dueTodayMessage', INITIAL_CONFIG.dueTodayMessage)}
                >
                  <div className="alert alert-primary py-2 small mb-3">
                    ℹ️ Enviada <strong>no dia do vencimento</strong>.
                  </div>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Mensagem</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="dueTodayMessage"
                      value={config.dueTodayMessage} onChange={handleChange}
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>
            </Row>

            {/* ══════════════════════════════════════
                BLOCOS — APÓS VENC. | CONFIRMAÇÃO
            ══════════════════════════════════════ */}
            <Row className="g-4">
              <Col md={6}>
                <NotificationSection
                  title="Após o Vencimento" icon={<FaBell />} color="danger"
                  enabled={config.afterDueEnabled} onToggle={v => set('afterDueEnabled', v)}
                  onReset={() => set('afterDueMessage', INITIAL_CONFIG.afterDueMessage)}
                >
                  <Row className="g-3 mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias após (mínimo)</Form.Label>
                        <Form.Control
                          type="number" name="afterDueDaysMin"
                          value={config.afterDueDaysMin} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 1</Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias após (máximo)</Form.Label>
                        <Form.Control
                          type="number" name="afterDueDaysMax"
                          value={config.afterDueDaysMax} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 15</Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="alert alert-danger py-2 small">
                    ⚠️ Enviado de <strong>{config.afterDueDaysMin}</strong> até{' '}
                    <strong>{config.afterDueDaysMax}</strong> dia(s) após o vencimento.
                  </div>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Mensagem</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="afterDueMessage"
                      value={config.afterDueMessage} onChange={handleChange}
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>

              <Col md={6}>
                {/* <NotificationSection
                  title="Confirmação de Pagamento" icon={<FaCheckCircle />} color="success"
                  enabled={config.paymentConfirmEnabled} onToggle={v => set('paymentConfirmEnabled', v)}
                  onReset={() => set('paymentConfirmMessage', INITIAL_CONFIG.paymentConfirmMessage)}
                >
                  <div className="alert alert-success py-2 small mb-3">
                    ✅ Enviada automaticamente quando o pagamento é confirmado.
                  </div>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Mensagem</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="paymentConfirmMessage"
                      value={config.paymentConfirmMessage} onChange={handleChange}
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection> */}
              </Col>
            </Row>

            {/* ══════════════════════════════════════
                BOTÕES DAS MENSAGENS
            ══════════════════════════════════════ */}
            <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

              <Button
                variant="outline-secondary" type="button"
                disabled={savingMsgs || testing}
                onClick={handleResetMessages}
              >
                <FaUndo className="me-2" />
                Resetar Mensagens
              </Button>

              <Button
                variant="outline-info" type="button"
                disabled={testing || savingMsgs}
                onClick={() => handleTestRun(true)}
              >
                {testing
                  ? <Spinner size="sm" animation="border" className="me-2" />
                  : <FaEye className="me-2" />
                }
                Simular Envio
              </Button>

              <Button
                variant="outline-warning" type="button"
                disabled={testing || savingMsgs}
                onClick={() => {
                  if (window.confirm('⚠️ Isso vai enviar mensagens REAIS agora para os clientes. Confirmar?')) {
                    handleTestRun(false);
                  }
                }}
              >
                {testing
                  ? <Spinner size="sm" animation="border" className="me-2" />
                  : <FaPlay className="me-2" />
                }
                Disparar Agora
              </Button>

              <Button variant="success" type="submit" disabled={savingMsgs || testing} size="lg">
                {savingMsgs
                  ? <><Spinner size="sm" className="me-2" />Salvando...</>
                  : <><FaSave className="me-2" />Salvar Mensagens</>
                }
              </Button>
            </div>

            {/* ══════════════════════════════════════
                PREVIEW — resultado do Dry Run
            ══════════════════════════════════════ */}
            {preview.length > 0 && (
              <Card className="border-info shadow-sm">
                <Card.Header className="bg-info bg-opacity-10 d-flex justify-content-between align-items-center">
                  <strong className="d-flex align-items-center gap-2">
                    <FaEye className="text-info" />
                    Preview — {preview.length} notificação(ões) seriam enviadas
                  </strong>
                  <Button size="sm" variant="outline-secondary" onClick={() => setPreview([])}>
                    Fechar
                  </Button>
                </Card.Header>
                <Card.Body className="p-0">
                  <Table hover responsive className="mb-0 small">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '20%' }}>Cliente</th>
                        <th style={{ width: '15%' }}>Telefone</th>
                        <th>Mensagem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {preview.map((p, i) => (
                        <tr key={i}>
                          <td className="fw-semibold">{p.cliente}</td>
                          <td><code>{p.telefone}</code></td>
                          <td>
                            <pre style={{ fontSize: '0.75rem', whiteSpace: 'pre-wrap', margin: 0, fontFamily: 'inherit' }}>
                              {p.mensagem}
                            </pre>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            )}

          </div>
        </Form>

      </div>
    </Container>
  );
}
